import { reportsApi } from 'Api/axios/reports-api';
import { useEffect, useState } from 'react';
import { EmployeeCoursesReportFilterI, EmployeeCoursesReportI, EmployeeCoursesReportTotalsI } from 'types';

const defaultTotals: EmployeeCoursesReportTotalsI = {
  totalCourses: 0,
  completedCourses: 0,
  pendingCourses: 0,
  approvedEvaluations: 0,
  totalTrainingHours: '00:00:00',
};

interface Props {
  employeeId: string;
  init?: boolean;
}

const useEmployeeCoursesReportApi = ({ employeeId, init = false }: Props) => {
  const [data, setData] = useState<Array<EmployeeCoursesReportI>>([]);
  const [totals, setTotals] = useState<EmployeeCoursesReportTotalsI>(defaultTotals);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(null);

  /**
   * Obtiene los cursos de un empleado en específico.
   * @param id - El ID del empleado.
   * @param filters - Los filtros para la consulta.
   */
  const fetchEmployeeCourses = async (id: string, filters: EmployeeCoursesReportFilterI) => {
    setLoading(true);
    const response = await reportsApi.readCoursesByEmployee(id, filters);
    setLoading(false);
    setData(response.data ?? []);
    setError(response.error);
  };

  const fetchEmployeeCoursesTotals = async (id: string) => {
    setLoading(true);
    const response = await reportsApi.readCoursesByEmployeeTotals(id);
    setLoading(false);
    setTotals(response.data ?? defaultTotals);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchEmployeeCourses(employeeId, {});
      fetchEmployeeCoursesTotals(employeeId);
    }
  }, [init]);

  return {
    data,
    totals,
    loading,
    error,
    fetchEmployeeCourses,
    fetchEmployeeCoursesTotals,
  };
};

export default useEmployeeCoursesReportApi;
